import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import Dashboard from '@/pages/Dashboard';
import Calendars from '@/pages/Calendars';
import CalendarView from '@/pages/CalendarView';
import Events from '@/pages/Events';
import Admin from '@/pages/Admin';

function App() {
  const [token, setToken] = useState(localStorage.getItem('coagenda_token'));
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) {
      fetchUserInfo();
    }
  }, [token]);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setUser(data);
      } else {
        logout();
      }
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  const login = (newToken) => {
    localStorage.setItem('coagenda_token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('coagenda_token');
    setToken(null);
    setUser(null);
  };

  const ProtectedRoute = ({ children }) => {
    return token ? children : <Navigate to="/login" />;
  };

  const AdminRoute = ({ children }) => {
    return token && user?.is_admin ? children : <Navigate to="/dashboard" />;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!token ? <Login onLogin={login} /> : <Navigate to="/dashboard" />} />
          <Route path="/register" element={!token ? <Register /> : <Navigate to="/dashboard" />} />
          <Route path="/forgot-password" element={!token ? <ForgotPassword /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard token={token} user={user} onLogout={logout} /></ProtectedRoute>} />
          <Route path="/calendars" element={<ProtectedRoute><Calendars token={token} user={user} onLogout={logout} /></ProtectedRoute>} />
          <Route path="/calendar/:calendarId" element={<ProtectedRoute><CalendarView token={token} user={user} onLogout={logout} /></ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute><Events token={token} user={user} onLogout={logout} /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin token={token} user={user} onLogout={logout} /></AdminRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
